import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';

import { ExcelService } from '../excel.service';
import { FormBuilder, FormGroup, Validators, FormGroupDirective, NgForm } from '@angular/forms';
import * as moment from 'moment';
import { VillageStaffService } from '../village-staff.service';
import { vovSharedService } from 'src/app/shared/services/vov-shared.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';


@Component({
  selector: 'app-waviers',
  templateUrl: './waviers.component.html',
  styleUrls: ['./waviers.component.scss']
})
export class WaviersComponent implements OnInit {
  public waviers = [];
  public confirmDialog: MatDialogRef<any> = null;
  public columnNames = {
    'Plate No': 'PlateNo.',
    'Date': 'Date',
    'Street#': 'Street#',
    'Street': 'Street',
    'Reason': 'Reason',
    'FirstName': 'First Name',
    'LastName': 'Last Name',
    'Address': 'Address',
    'City': 'City',
    'State': 'State',
    'Zipcode': 'Zip',
    'Phone': 'Phone',
    'Email': 'Email',
    'RemainingCount': 'Waivers Left',
    // 'Year': 'Year',
    'edit': '',
  };
  public showSpinner: boolean = false;
  public todayDate = new Date();
  public minDate = new Date(2020, 0, 1);
  public firstYearDate = moment().startOf('year').format('YYYY-MM-DD');
  dateForm: FormGroup;
  updateWaiverForm: FormGroup
  public streets = [];
  public selectedItem: any;
  @ViewChild('confirmRef') confirmRef: TemplateRef<any>;
  constructor(private excelService: ExcelService,
    private villageStaffService: VillageStaffService,
    private formBuilder: FormBuilder,
    private vovSharedService: vovSharedService,
    public dialog: MatDialog,
    private _snackBar: MatSnackBar,
  ) { }

  ngOnInit(): void {
    this.dateForm = this.formBuilder.group({
      startDate: [''],
      endDate: [''],
      plateNo: [''],
      street: ['']
    });

    this.updateWaiverForm = this.formBuilder.group({
      waiverCount: ['']
    });

    this.onSubmitDates();
    this.vovSharedService.fetchAllStreets().subscribe((res) => {
      this.streets = res.streetsList;
      this.streets.sort((a, b) => a.street.localeCompare(b.street));
    });

  }

  onSubmitDates() {
    console.log('resett')
    this.showSpinner = true;
    console.log(this.dateForm.value)
    let params = this.dateForm.value
    // params.startDate = params.startDate ? moment(params.startDate).format('YYYY-MM-DD') : moment(this.firstYearDate).format('YYYY-MM-DD');
    // params.endDate = params.endDate ? moment(params.endDate).format('YYYY-MM-DD') : moment(new Date()).format('YYYY-MM-DD');
    params.startDate = params.startDate ? moment(params.startDate).format('YYYY-MM-DD') : null;
    params.endDate = params.endDate ? moment(params.endDate).format('YYYY-MM-DD') : null;
    console.log(params)
    this.villageStaffService.getVillageStaffWavier(params).subscribe((res: any) => {
      let wavier = [];
      res.result.sort((a, b) => <any>new Date(b.startDate).getTime() - <any>new Date(a.startDate).getTime());

      res.result.map((data: any) => {
        if (data.waiver_vehicle) {

          const statePlate = data.states.state + '-' + data.waiver_vehicle.vehicle.plateNo;
          // const totalCount = (data.waiver_vehicle && data.waiver_vehicle.vehicle && data.waiver_vehicle.vehicle.waiver_count && data.waiver_vehicle.vehicle.waiver_count) ? data.waiver_vehicle.vehicle.waiver_count[0].total_parked : null;
          // let yearWiseCount
          // if (data.waiver_vehicle.vehicle.waiver_count) {
          //   yearWiseCount = data.waiver_vehicle.vehicle.waiver_count.find(c => c.yearId == data.yearId);
          // }
          const totalCount = (data.waiver_vehicle && data.waiver_vehicle.vehicle && data.waiver_vehicle.vehicle.waiver_count && data.waiver_vehicle.vehicle.waiver_count) ? data.waiver_vehicle.vehicle.waiver_count[0].total_parked : null;
          let remainingCount;
          var d = new Date(data.startDate);
          const currentYear = d.getFullYear();
          // if (currentYear == 2020) {
          //   remainingCount = - totalCount;
          // } else {
          // if (data.cycle && data.cycle.limit) {
          //   remainingCount = data.cycle.limit - totalCount;
          // }
          // // }
          let issuedDate = moment(data.startDate).format("YYYY-MM-DD")
          let currentDate = moment(new Date()).format("YYYY-MM-DD")
          let valid;
          if (issuedDate < currentDate) {
            valid = true;
          } else {
            valid = false;
          }
          let phoneNo;
          if (data.waiver_vehicle.waiver) {
            phoneNo = data.waiver_vehicle.waiver ? data.waiver_vehicle.waiver.phone_no : null;
            //phoneNo = str.substr(0, 6) + '****'
          }
          let wavierData = {
            'Plate No': statePlate,
            'plateNo': data.waiver_vehicle.vehicle.plateNo,
            'Date': moment(data.startDate).format("MM/DD/YY"),
            'Street#': data.streetNumber ? data.streetNumber : '0',
            'Street': data.streets ? data.streets.street : null,
            'Reason': data.parking_reason ? data.parking_reason.reason : null,
            'FirstName': (data.waiver_vehicle && data.waiver_vehicle.waiver) ? data.waiver_vehicle.waiver.firstName : null,
            'LastName': (data.waiver_vehicle && data.waiver_vehicle.waiver) ? data.waiver_vehicle.waiver.lastName : null,
            'Address': (data.waiver_vehicle && data.waiver_vehicle.waiver) ? data.waiver_vehicle.waiver.address : null,
            'City': (data.waiver_vehicle && data.waiver_vehicle.waiver) ? data.waiver_vehicle.waiver.city : null,
            'State': (data.waiver_vehicle && data.waiver_vehicle.waiver) ? data.waiver_vehicle.waiver.states.state : null,
            'Zipcode': (data.waiver_vehicle && data.waiver_vehicle.waiver) ? data.waiver_vehicle.waiver.zipcode : null,
            // 'Phone': (data.waiver_vehicle && data.waiver_vehicle.waiver) ? data.waiver_vehicle.waiver.phone_no : null,
            'Phone': phoneNo ? phoneNo : null,
            'Email':(data.waiver_vehicle && data.waiver_vehicle.waiver) ? data.waiver_vehicle.waiver.email.toLowerCase() : null,
            //'Email': (data.waiver_vehicle && data.waiver_vehicle.waiver) ? data.waiver_vehicle.waiver.email : null,
            'RemainingCount': data.remainingCount ? data.remainingCount : '0',
            'Waivers Left': data.remainingCount ? data.remainingCount : '0',
            'cycleId': data.cycleId,
            'id': data.id,
            'excluded': valid
            // 'Year': (data.years && data.years.year) ? data.years && data.years.year : null
          }
          wavier.push(wavierData)
        }

      })
      console.log(wavier, 'waveir')
      this.waviers = wavier;
      this.showSpinner = false;
    });
  }

  reset() {
    this.dateForm.reset()
    this.onSubmitDates();
  }

  selectedItems(item) {
    this.selectedItem = item.data;
    if (item.action === 'edit') {
      this.updateWaiverForm.patchValue({
        waiverCount: this.selectedItem.RemainingCount,
      });
      this.confirmDialog = this.dialog.open(this.confirmRef, {
        width: '350px',
        data: 'data'
      });
    } else {
      this.confirmDialog = this.dialog.open(this.confirmRef, {
        width: '350px',
        data: 'data'
      });
    }
  }

  confirmUpdate() {
    this.updateWaiver(this.selectedItem);
    // this.fetchAllCycles();
    this.confirmDialog.close();
    this.selectedItem = '';
  }

  updateWaiver(waiver) {
    this.updateWaiverForm.value['plateNo'] = waiver.plateNo
    this.updateWaiverForm.value['cycleId'] = waiver.cycleId
    this.updateWaiverForm.value['currentDate'] = new Date();
    this.updateWaiverForm.value['vehicleDetailsId'] = waiver.id;
    this.villageStaffService.updateWaiverCount(this.updateWaiverForm.value).subscribe((res) => {
      if (res.message == 'Limit updated successfully') {
        this._snackBar.open('Success :' + res.message, '', {
          duration: 5000,
          horizontalPosition: 'right',
          panelClass: 'success-snackbar'
        });
        console.log(res)
        this.onSubmitDates();
      } else {
        this._snackBar.open('Warning:' + res.message, '', {
          duration: 5000,
          horizontalPosition: 'right',
          panelClass: 'warning-snackbar'
        });
        return;
        console.log(res)
      }

      // this.fetchAllCycles();
    }, error => {
      let errorMessage: string;
      if (error.error.message) {
        errorMessage = error.error.message;
      } else {
        errorMessage = `${error.message}`;
      }
      if (errorMessage == '') {
        this._snackBar.open('Warning :' + errorMessage, '', {
          duration: 3000,
          horizontalPosition: 'right',
          panelClass: 'warning-snackbar'
        });
        this.showSpinner = false;
      } else {
        console.log(error);
        this._snackBar.open('Warning :' + errorMessage, '', {
          duration: 3000,
          horizontalPosition: 'right',
          panelClass: 'warning-snackbar'
        });
        this.showSpinner = false;
      }

    });
    // this.fetchAllCycles();
  }


  onNoClick() {
    this.confirmDialog.close();
  }

  exportAsXLSX(): void {
    const exportReport = this.waviers.map(({ plateNo, cycleId, id, excluded, RemainingCount, ...rest }) => rest);
    this.excelService.exportAsExcelFile(exportReport, 'sample');
  }

  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode >= 96 && charCode <= 106) {
      return true;
    }
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
}
